let $body = document.body
let $header = document.querySelector('.js-header')

export function getOffset($el, align = 'top') {
  let bodyRect = $body.getBoundingClientRect()
  let elemRect = $el.getBoundingClientRect()
  let offset = elemRect.top - bodyRect.top

  if (align === 'top') {
    offset = offset - 30
  } else if (align === 'middle') {
    offset = offset - window.innerHeight / 2
  }

  if ($header) {
    offset = offset - $header.getBoundingClientRect().height
  }

  return offset
}

export function scrollToPosition(y, smooth = true) {
  if ('scrollBehavior' in document.documentElement.style) {
    window.scrollTo({
      top: y,
      left: 0,
      behavior: smooth ? 'smooth' : 'auto'
    })
  } else {
    window.scrollTo(0, y)
  }
}

export function scrollToElement($el, smooth = true, align = 'top') {
  scrollToPosition(getOffset($el, align), smooth)
}

export function pad(pad, str, padLeft = true) {
  if (typeof str === 'undefined') {
    return pad
  }
  if (padLeft) {
    return (pad + str).slice(-pad.length)
  } else {
    return (str + pad).substring(0, pad.length)
  }
}

export function removeClass($el, classNames) {
  if (!Array.isArray(classNames)) classNames = [classNames]
  classNames.forEach(className => {
    $el.classList.remove(className)
  })
}

export function addClass($el, classNames) {
  if (!Array.isArray(classNames)) classNames = [classNames]
  classNames.forEach(className => {
    $el.classList.add(className)
  })
}

export function toggleClass($el, classNames) {
  if (!Array.isArray(classNames)) classNames = [classNames]
  classNames.forEach(className => {
    $el.classList.toggle(className)
  })
}

export function toggleLinkRowClasses($buttons, $button) {
  $buttons
    .filter($b => $b !== $button)
    .forEach($b => {
      removeClass($b, [
        'mx-4',
        'text-current',
        'no-underline',
        'echo',
        'relative'
      ])
      addClass($b, [
        'mx-4',
        'text-grey-dark',
        'hover:text-black',
        'transition-color',
        'no-underline',
        'echo',
        'relative',
        'appearance-none',
        'p-0',
        'line-behind-hidden'
      ])
    })

  removeClass($button, [
    'mx-4',
    'text-grey-dark',
    'hover:text-black',
    'transition-color',
    'no-underline',
    'echo',
    'relative',
    'appearance-none',
    'p-0',
    'line-behind-hidden'
  ])
  addClass($button, [
    'mx-4',
    'text-current',
    'no-underline',
    'echo',
    'relative'
  ])
}

export function isDescendant(parent, child) {
  var node = child.parentNode
  while (node != null) {
    if (node === parent) {
      return true
    }
    node = node.parentNode
  }
  return false
}

export const Key = {
  ENTER: 13,
  ESCAPE: 27,
  HOME: 36,
  END: 35,
  UP: 38,
  DOWN: 40
}

export function getTimes(start = 0, end = 24, interval = 5) {
  let times = [] // time array
  let tt = start * 60 // start time

  // loop to increment the time and push results in array
  for (let i = 0; tt < end * 60; i++) {
    let hh = Math.floor(tt / 60) // getting hours of day in 0-24 format
    let mm = tt % 60 // getting minutes of the hour in 0-55 format
    times[i] = ('0' + hh).slice(-2) + ':' + ('0' + mm).slice(-2)
    tt = tt + interval
  }

  return times
}



// WEBPACK FOOTER //
// ./src/js/utils.js